module.exports = __webpack_public_path__ + "static/ctaBackground-74866ed432cf32c296deddbd3a94e401.svg";